module.exports = __webpack_public_path__ + "img/kakaotalk.80f9f475.png";